import L from "leaflet";
import "leaflet.elevation/dist/Leaflet.Elevation-0.0.2.min.js";

/**
 * Custom plugin to add error catching to Leaflet.Elevation functions that are prone to errors.
 */
L.Control.ExtendElevation = L.Control.Elevation.extend({
  _mousemoveHandler: function (e) {
    try {
      L.Control.Elevation.prototype._mousemoveHandler.call(this, e);
    } catch (error) {

    }
  },

  _showDiagramIndicator: function (e) {
    try {
      L.Control.Elevation.prototype._showDiagramIndicator.call(this, e);
    } catch (error) {

    }
  },

  _calculateFullExtent: function (e) {
    try {
      L.Control.Elevation.prototype._calculateFullExtent.call(this, e);
    } catch (error) {

    }
  },

  _fitSection: function (e) {
    try {
      L.Control.Elevation.prototype._fitSection.call(this, e);
    } catch (error) {

    }
  },

  /**
   * Disable dragging on the graph. Its buggy and doesnt work half the time, so better to just disable it.
   */
  _dragStartHandler: function (e) {
    return null;
  },
});

L.control.extendElevation = function (options) {
  return new L.Control.ExtendElevation(options);
};